import { coreAxios } from "utilities/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from 'react-toastify';


const BASE_URL = process.env.REACT_APP_MAIN_URL

export const AddEmployee = createAsyncThunk(
  "employee/AddEmployee",
  async (data) => {
    const response = await coreAxios.post(`${BASE_URL}/api/employee-create/`, data)
    return response.data
  }
); 

export const UpdateEmployee = createAsyncThunk(
  "employee/UpdateEmployee",
  async (data) => {
    const response = await coreAxios.put(`${BASE_URL}/api/employee-update/${data.id}/`, data)
    return response.data
  }
);

export const GetEmployeeList = createAsyncThunk(
  "employee/GetEmployeeList",
  async () => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/employee-list/`)
    return data
  }
);

export const GetEmployeeNameList = createAsyncThunk(
  "employee/GetEmployeeNameList",
  async () => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/employee-name-list/`)
    return data
  }
);

export const GetEmployeeIdList = createAsyncThunk(
  "employee/GetEmployeeIdList",
  async () => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/employee-id-list/`)
    return data
  }
);

export const GetEmployeeAssetList = createAsyncThunk(
  "employee/GetEmployeeAssetList",
  async (id) => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/employee-asset-list/${id}/`)
    return data
  }
);

export const GetEmployeeDetail = createAsyncThunk(
  "employee/GetEmployeeDetails",
  async (id) => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/employee-detail/${id}/`)
    return data
  }
);

export const DeleteEmployee = createAsyncThunk(
  "employee/DeleteEmployee",
  async (id) => {
    const response = await coreAxios.delete(`${BASE_URL}/api/employee-delete/${id}/`)
    if (response.status === 226){
      toast.warning(response.data.message)
    }
    return response.status
  }
);

